import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import FlatButton from 'material-ui/FlatButton'

import JobCard from '../common/JobCard'
import ScheduleUtils from '../common/ScheduleUtils'
import { startCalendarSync, stopCalendarSync } from 'infra/actions/calendars'

import './WeekView.css'
import _ from 'lodash'

class WorkerDay extends React.Component {

  static propTypes = {
    dateStr: PropTypes.string.isRequired,
    isToday: PropTypes.bool,
    worker: PropTypes.object.isRequired,
    teamId: PropTypes.string.isRequired,
    instances: PropTypes.array,
    calendarEvents: PropTypes.object,
    calendarDisplay: PropTypes.object,
    dispatch: PropTypes.func.isRequired
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dateStr !== this.props.dateStr) {
      this.detachLoaders(this.props.dateStr)
      this.setState({
        jobs: false,
        reportInfo: false
      })
      this.initLoaders(nextProps.dateStr)
    }
  }

  componentWillMount() {
    this.initLoaders(this.props.dateStr)
  }

  componentWillUnmount() {
    this.detachLoaders(this.props.dateStr)
  }

  shouldComponentUpdate(nextProps, nextState){

    if (this.state !== nextState){
      return true
    } else if (this.props.instances !== nextProps.instances){
      return true
    } else if (this.props.calendarDisplay !== nextProps.calendarDisplay){
      return true
    } else if (this.props.teamId !== nextProps.teamId){
      return true
    } else if (this.calendarEventsChanged(this.props.calendarEvents, nextProps.calendarEvents)){
      return true
    }

    return false
  }

  calendarEventsChanged(oldCalendarEvents, newCalendarEvents) {
    _.keys(newCalendarEvents).forEach(id => {
      const newEvent = newCalendarEvents[id]
      const oldEvent = oldCalendarEvents[id]
      if (newEvent !== oldEvent){
        return true
      }
    })

    return false
  }

  initLoaders(dateStr) {
    const calendarId = this.getCalendarId()
    this.props.dispatch(startCalendarSync(calendarId, dateStr))
  }

  detachLoaders(dateStr) {
    const calendarId = this.getCalendarId()
    this.props.dispatch(stopCalendarSync(calendarId, dateStr))
  }

  getCalendarId() {
    const userId = this.props.worker.userId
    return `${userId}@${this.props.teamId}`
  }

  renderWorkItemsByDay() {
    if (!this.props.instances) {
      return null
    }

    const sortedInstances = ScheduleUtils.getSortedInstancesIds(this.props.instances,
      this.props.calendarEvents, this.props.calendarDisplay, this.getCalendarId(), this.props.dateStr)

    return sortedInstances.map(instanceId => (
      <JobCard
        style={{ marginTop: 6, height: 64, width: '95%' }}
        key={instanceId}
        eventId={instanceId}
        userId={this.props.worker.userId}
        dateStr={this.props.dateStr} />
    ))
  }

  handleAddJobClicked = () => {
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: 'ADD_JOB',
      value: {
        anchorButton: this.addJobButtonRef,
        dateStr: this.props.dateStr,
        workerId: this.props.worker.userId
      }
    })
  }

  render() {

    return (
      <div key={this.props.dayKey} style={styles.workerRowDay(this.props.isToday)}>
        { this.renderWorkItemsByDay() }
        <FlatButton
          ref={addJobButton => this.addJobButtonRef = addJobButton}
          style={styles.addEventButton}
          className='week-view-add-event'
          onTouchTap={this.handleAddJobClicked}>
          +
        </FlatButton>
      </div>
    )
  }
}

const styles = {
  workerRowDay: isToday => ({
    margin: 0,
    minHeight: 64,
    flexShrink: 0,
    flexGrow:0,
    flex: 1,
    minWidth: 0,
    backgroundColor: isToday ? 'rgba(0, 0, 0, 0.04)' : undefined,
    borderRight: '#e0e0e0 1px solid',
    borderBottom: '#e0e0e0 1px solid',
    overflowX: 'hidden'
  }),
  addEventButton: {
    height: 32,
    width: 32,
    minWidth: 32,
    margin: 8,
    borderRadius: 16,
    lineHeight: undefined,
    color: '#455559',
    border: 'solid 1px #bdbdbd'
  }
}

const mapStateToProps = (state, ownProps) => {
  const userId = ownProps.worker.userId
  const teamId = state.firebase.team.metadata.value.id
  const combinedId = `${userId}@${teamId}->${ownProps.dateStr}`

  const instances = state.schedule.instances[combinedId]

  const calendarEvents = {}
  if (instances){
    instances.forEach(instance => {
      const { eventId } = instance
      const event = state.firebase.calendarEvents[eventId]
      if (event){
        calendarEvents[eventId] = event
      }
    })
  }

  return {
    instances,
    calendarEvents,
    calendarDisplay: state.firebase.calendarDisplay[combinedId],
    teamId
  }
}

export default connect(mapStateToProps)(WorkerDay)



// WEBPACK FOOTER //
// ./src/schedule/week/WorkerDay.js